<template>
  <div class="page-content form-submit-page" style="margin-top: 20px;height: 85%">
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">积分设置</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content" style="height: 90%">
      <div class="box-content-div form-submit-page">
        <el-form :inline="false" :model="formInline" ref="formInline" :rules="rules" class="box-content-form" label-width="160px">
          <el-form-item label="订单转化比例:" prop="integral_proportion">
            <div style="display: flex; justify-content: flex-start; flex-direction: row;">
              <el-input step="0.01" v-model="formInline.integral_proportion" placeholder="请输入订单转化比例" type="number"></el-input><span style="margin-left: 5px;color: #333;font-size: 12px">%</span>
              <el-tooltip class="item" effect="dark" content="*积分=订单实际支付金额*订单转化比例！" placement="right">
                <i class="el-icon-question" style="margin-top: 10px; margin-left: 5px;"></i>
              </el-tooltip>
            </div>
            <!-- <div class="order-content">
              <el-input v-model="formInline.integral_proportion" placeholder="请输入订单转化比例" type="number"></el-input>
              <span style="color: #333;font-size: 12px">*积分=订单实际支付金额*订单转化比例！</span>
            </div> -->
          </el-form-item>
          <el-form-item label="每日积分上限:" prop="behavior_integral_limit">
            <el-input step="0.01" v-model="formInline.behavior_integral_limit" placeholder="请输入每日积分上限" type="number"></el-input>
          </el-form-item>
          <el-form-item label="扫码积分比例:" prop="scan_ratio">
            <div class="content-item">
              <el-input step="0.01" v-model="formInline.scan_ratio" placeholder="请输入扫码积分比例" type="number" maxlength="3" :max="100" :min="0"></el-input><span style="margin-left: 5px;color: #333;font-size: 12px">%</span>
            </div>
          </el-form-item>
          <el-form-item label="积分有效期:" prop="integral_date">
            <div class="content-item">
              <el-input step="0.01" v-model="formInline.integral_date" placeholder="请输入积分有效期" type="number"></el-input><span style="margin-left: 5px;color: #333;font-size: 12px">(天)</span>
            </div>
          </el-form-item>
          <!--<el-form-item label="登录积分:" prop="login_integration">-->
            <!--<el-input v-model="formInline.login_integration" placeholder="请输入登录积分" type="number"></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="积分比例:" prop="integral_proportion">-->
            <!--<el-input v-model="formInline.integral_proportion" placeholder="请输入积分比例" type="number"></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="注册积分:"  prop="register_integration">-->
            <!--<el-input v-model="formInline.register_integration" placeholder="请输入注册积分" type="number"></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="行为积分:" prop="behavior_integral_limit">-->
            <!--<el-input v-model="formInline.behavior_integral_limit" placeholder="请输入行为积分" type="number"></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="推荐有礼积分:" prop="recommend_integral">-->
            <!--<el-input v-model="formInline.recommend_integral" placeholder="请输入推荐有礼积分" type="number"></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="积分有效期:" prop="integral_date">-->
            <!--<el-input v-model="formInline.integral_date" placeholder="请输入积分有效期" type="number"></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="积分活跃度兑换比例:" prop="dh_dmp_bili">-->
            <!--<el-input v-model="formInline.dh_dmp_bili" placeholder="请输入积分活跃度兑换比例" type="number"></el-input>-->
          <!--</el-form-item>-->
          <el-form-item style="margin-top: 92px">
            <el-button class="second-page-btn" style="margin-left: 0px;float: left" type="primary" @click="submitForm('formInline')">保存</el-button>
          </el-form-item>
        </el-form>
        <!--<el-form :inline="false" :model="formInline" class="box-content-form2" label-width="10px">-->
          <!--<el-form-item v-for="item in infoArray" :key="item" style="text-align: left;">-->
            <!--<span class="tip-info">{{item}}</span>-->
          <!--</el-form-item>-->
        <!--</el-form>-->
      </div>
    </el-row>
  </div>
</template>
<script>
import { getIntegralSettingInfo, changeIntegralSetting } from '@/api/customer.js'
export default {
  name: '',
  data () {
    return {
      infoArray: [],
      formInline: {
        login_integration: '',
        integral_proportion: '',
        recommend_integral: '',
        register_integration: '',
        behavior_integral_limit: '',
        scan_ratio: 0,
        integral_date: ''
        // dh_dmp_bili: ''
      },
      rules: {
        login_integration: [
          { required: true, message: '请输入登录积分', trigger: 'blur' }
        ],
        // integral_proportion: [
        //   { required: true, message: '请输入积分比例', trigger: 'blur' }
        // ],
        register_integration: [
          { required: true, message: '请输入注册积分', trigger: 'blur' }
        ],
        behavior_integral_limit: [
          { required: true, message: '请输入行为积分', trigger: 'blur' }
        ],
        scan_ratio: [
          { required: true, message: '请输入扫码积分比例', trigger: 'blur' }
        ],
        recommend_integral: [
          { required: true, message: '请输入行为积分', trigger: 'blur' }
        ],
        integral_date: [
          { required: true, message: '请输入积分有效期', trigger: 'blur' }
        ]
        // dh_dmp_bili: [
        //   { required: true, message: '请输入积分活跃度兑换比例', trigger: 'blur' }
        // ]
      },
      options: [],
      value: ''
    }
  },
  methods: {
    isNumber(value) {
      if (value === 1 && parseFloat(this.formInline.login_integration).toString() == 'NaN') {
        _g.toastMsg('error', '请输入数字')
        this.formInline.login_integration = ''
      } else if (value === 2 && parseFloat(this.formInline.integral_proportion).toString() == 'NaN') {
        _g.toastMsg('error', '请输入数字')
        this.formInline.integral_proportion = ''
      } else if (value === 3 && parseFloat(this.formInline.register_integration).toString() == 'NaN') {
        _g.toastMsg('error', '请输入数字')
        this.formInline.register_integration = ''
      } else if (value === 4 && parseFloat(this.formInline.behavior_integral_limit).toString() == 'NaN') {
        _g.toastMsg('error', '请输入数字')
        this.formInline.behavior_integral_limit = ''
      } else if (value === 4 && parseFloat(this.formInline.scan_ratio).toString() == 'NaN') {
        _g.toastMsg('error', '请输入数字')
        this.formInline.scan_ratio = ''
      } else if (value === 5 && parseFloat(this.formInline.dh_dmp_bili).toString() == 'NaN') {
        _g.toastMsg('error', '请输入数字')
        this.formInline.dh_dmp_bili = ''
      }
    },
    submitForm(formName) {
      if (this.formInline.integral_proportion > 100) {
        _g.toastMsg('error', '订单转化比不能大于100')
        return
      }
      if (this.formInline.scan_ratio > 100) {
        _g.toastMsg('error', '积分比例不能大于100')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveIntegralSettingInfo()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getData() {
      getIntegralSettingInfo().then(res => {
        this.formInline.login_integration = res.data.data.list[0].value
        this.formInline.integral_proportion = res.data.data.list[1].value
        this.formInline.register_integration = res.data.data.list[2].value
        this.formInline.behavior_integral_limit = res.data.data.list[3].value
        this.formInline.recommend_integral = res.data.data.list[5].value
        this.formInline.integral_date = res.data.data.list[6].value
        this.formInline.scan_ratio = res.data.data.list[7].value
        // this.formInline.dh_dmp_bili = res.data.data.list[4].value
        for (let item of res.data.data.list) {
          this.infoArray.push(item.info)
        }
      })
    },
    saveIntegralSettingInfo() {
      changeIntegralSetting(this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  created() {
    this.getData()
  },
  mounted() {
  },
  components: {
  }
}
</script>

<style scoped>
@media only screen and (max-width: 1450px) {
  .box-content-form .order-content {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }
}
.order-content {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: 750px;
}
.box-content-form .order-content span {
  display: inline-block;
  width: 300px !important;
}
.box-content-div {
  width: 750px !important;
  padding-left: 20%;
  box-sizing: border-box;
}
.form-submit-page .el-form-item{
  width: 100%;
}
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.box-content-form {
  width: 100%;
  text-align: center;
}
.box-content-form2 {
  margin-top: 14px;
  margin-bottom: 5px;
}
.tip-info {
  display: block;
  height: 40px;
  line-height: 40px;
  color: #999;
}
.content-item {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
</style>
